import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormNewEntryActivity } from '@/typings/domain'
import { useRouter } from 'expo-router'
import ItemWrapper from './ItemWrapper'

export default function MergedNewEntry({ notification }: { notification: NotificationType }) {
  const router = useRouter()

  const activity = notification.activity as FormNewEntryActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  const handlePress = () => {
    if (!formInfo.formToken) return

    router.push({
      pathname: '/forms/[formToken]/entries',
      params: { formToken: formInfo.formToken },
    })
  }

  return (
    <ItemWrapper notification={notification} onPress={handlePress}>
      《{formInfo.formName}》新增 {notification.count} 条数据
    </ItemWrapper>
  )
}
